const shortDate = value => value ? String(value).slice(0, 10).split('-').reverse().join('/') : '-'

export const buildReceiptItemDescription = item => {
  const freeLabel = item?.is_free === true || Number(item?.is_free) === 1 ? ' [ของแถมฟรี]' : ''
  const productName = String(item.product_name || item.product_name_snapshot || item.description || '-').trim()
  const description = String(item.description || '').trim()
  const lines = [`${productName || '-'}${freeLabel}`]
  if (description && description !== productName) lines.push(description)
  if (item.barcode) lines.push(`SKU: ${item.barcode}`)
  const serials = Array.isArray(item.serials) ? item.serials : []
  if (serials.length) {
    lines.push(`Serial: ${serials.map(serial => serial.serial_number).join(', ')}`)
    lines.push(...serials.filter(serial => serial.shop_warranty_end_date || serial.manufacturer_warranty_end_date)
      .map(serial => {
        const shop = serial.shop_warranty_end_date ? `ร้านถึง ${shortDate(serial.shop_warranty_end_date)}` : ''
        const maker = serial.manufacturer_warranty_end_date ? `ผู้ผลิตถึง ${shortDate(serial.manufacturer_warranty_end_date)}` : ''
        return `ประกัน ${serial.serial_number}: ${[shop, maker].filter(Boolean).join(' / ')}`
      }))
  }
  return lines.join('\n')
}

export const buildReceiptItemQuantity = item => {
  const unit = item.unit_name_snapshot || item.unit || ''
  return `${item.quantity ?? 0}${unit ? ` ${unit}` : ''}`
}
